var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9276 9.52523L1.60209 0.464365C1.50101 0.408529 1.38649 0.379726 1.27021 0.380893C1.15393 0.382061 1.04005 0.413156 0.940182 0.471009C0.839685 0.526535 0.756132 0.606924 0.698025 0.703994C0.639917 0.801064 0.60933 0.911349 0.609375 1.02363C0.609375 1.02363 0.61592 1.85906 0.622465 3.2341L12.5145 14.7816L17.9276 9.52523Z",
    fill: "url(#paint0_linear_5695_33012)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.623047 3.23425C0.642979 8.19511 0.702476 20.2375 0.728953 26.2331L12.5226 14.7818L0.623047 3.23425Z",
    fill: "url(#paint1_linear_5695_33012)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2718 14.7113L17.9277 9.52539L12.5078 14.7829L18.6224 20.7205L27.2793 15.8237C27.3793 15.7677 27.4624 15.6872 27.5205 15.5902C27.5785 15.4933 27.6094 15.3833 27.6101 15.2711C27.6091 15.1572 27.5773 15.0456 27.518 14.9473C27.4586 14.8491 27.3737 14.7677 27.2718 14.7113Z",
    fill: "url(#paint2_linear_5695_33012)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.722656 26.2328C0.735746 28.3727 0.742588 29.7414 0.742588 29.7414C0.741609 29.8539 0.771803 29.9645 0.830005 30.0618C0.888208 30.159 0.972275 30.2392 1.07339 30.2941C1.17383 30.3508 1.28798 30.3808 1.4042 30.3808C1.52042 30.3808 1.63457 30.3508 1.73501 30.2941L18.6296 20.7256L12.5154 14.7881L0.722656 26.2328Z",
    fill: "url(#paint3_linear_5695_33012)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5695_33012",
    x1: 0.609375,
    y1: 7.58123,
    x2: 17.9276,
    y2: 7.58123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63BE6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#5BBC6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4AB96A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5695_33012",
    x1: 0.623047,
    y1: 14.7337,
    x2: 12.5107,
    y2: 14.7337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EC6F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45AFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5695_33012",
    x1: 12.5078,
    y1: 15.1229,
    x2: 27.6101,
    y2: 15.1229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA51A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#FAB716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#FAC412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC80F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5695_33012",
    x1: 0.722656,
    y1: 22.5844,
    x2: 18.6296,
    y2: 22.5844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC3B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7515B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreLogo);
export default __webpack_public_path__ + "static/media/play-store-logo.66e8c183d8ab3bf0f32d2d5a0d4244fc.svg";
export { ForwardRef as ReactComponent };